import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import {
  get_review_details,
  get_review_list,
  add_review,
  update_review
} from "../../../redux/actions/reviewActions";
import StarRatingComponent from "react-star-rating-component";

import languageConfig from "../../../config/languageConfig";

const history = createBrowserHistory();
class Reviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: "",
      msgType: "",
      show: false,
      review: "",
      rating: 0,
      reviewError: "",
      ratingError: "",
      reviewID: "",
      hideForm: false,
      dealID: "",
      default_lang: 'en',
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
    };
    this.validate = this.validate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onStarClick = this.onStarClick.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    e.preventDefault();
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleEdit = () => {
    this.setState({ hideForm: false });
  };

  onStarClick(nextValue, prevValue, name) {
    this.setState({ rating: nextValue });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (this.state.review.length === 0) {
      isError = true;
      this.setState({ reviewError: "red" });
    }
    if (this.state.rating === 0) {
      isError = true;
      this.setState({ ratingError: "red" });
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      if (this.state.reviewID !== "") {
        const updateData = {
          review: this.state.review,
          dealID: this.state.dealID,
          rating: this.state.rating
        };

        this.props.update_review(updateData);
      } else {
        const postData = {
          review: this.state.review,
          dealID: this.state.dealID,
          rating: this.state.rating
        };
        this.props.add_review(postData);
      }
    }
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({default_lang: siteData.default_lang,});
    }
    this.props.get_review_details(this.props.dealID);
    this.setState({ dealID: this.props.dealID });
  }

  componentWillUnmount() {
    this.props.clearAlert();
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.default_lang){
      this.setState({default_lang: nextProps.default_lang});
    }
    if (
      this.props.reviewDetails !== nextProps.reviewDetails &&
      !isEmpty(nextProps.reviewDetails)
    ) {
      this.setState({
        hideForm: true,
        reviewID: nextProps.reviewDetails.reviewID,
        rating: nextProps.reviewDetails.rating,
        review: nextProps.reviewDetails.review
      });
    }
    if (
      this.props.updatedReviewResponse !== nextProps.updatedReviewResponse &&
      !isEmpty(nextProps.updatedReviewResponse)
    ) {
      if (
        nextProps.updatedReviewResponse.response === "success" &&
        this.state.dealID !== ""
      ) {
        this.props.get_review_list(this.state.dealID);
        this.props.get_review_details(this.state.dealID);
        this.setState({ hideForm: true });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.updatedReviewResponse.message
        );
        window.scrollTo(0, 0);
      }
    }
    if (
      this.props.reviewResponse !== nextProps.reviewResponse &&
      !isEmpty(nextProps.reviewResponse)
    ) {
      if (nextProps.reviewResponse.response === "success") {
        this.props.get_review_list(this.state.dealID);
        this.props.get_review_details(this.state.dealID);
        this.setState({ hideForm: true });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.reviewResponse.message);
      }
    }
    if (this.props.error !== nextProps.error && nextProps.error !== "") {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
      window.scrollTo(0, 0);
    }
    if (this.props.message !== nextProps.message) {
      this.setState({ alertMessage: nextProps.message });
      window.scrollTo(0, 0);
    }
    if (this.props.alertType !== nextProps.alertType) {
      this.setState({ msgType: nextProps.alertType });
    }
  }

  render() {
    return (
      <div>
        {/*this.state.show &&
          this.state.alertMessage !== "" &&
          this.state.msgType && (
            <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
              </Alert>
            </div>
          )*/}
        {this.state.hideForm ? (
          <Button
            bsStyle="default"
            type="button"
            id="editButton"
            onClick={this.handleEdit}
          >
            {languageConfig[this.state.default_lang].edit_your_review}
          </Button>
        ) : (
          <form onSubmit={this.handleSubmit}>
            <Row>
              <Col md={12} xs={12}>
                <FormGroup controlId="formReview">
                  <ControlLabel>
                    <span style={{ color: "red" }}>*</span>{languageConfig[this.state.default_lang].reviews}
                  </ControlLabel>
                  <FormControl
                    value={this.state.review}
                    componentClass="textarea"
                    onChange={this.handleChange}
                    name="review"
                    placeholder={languageConfig[this.state.default_lang].give_review}
                    style={{ borderColor: this.state.reviewError }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12} xs={12}>
                <div>
                  <div style={{ fontWeight: "bold" }}>
                    <span style={{ color: "red" }}>*</span>{languageConfig[this.state.default_lang].rating}
                  </div>
                  <StarRatingComponent
                    name="rate1"
                    starCount={5}
                    value={this.state.rating}
                    onStarClick={this.onStarClick.bind(this)}
                  />
                </div>
              </Col>
            </Row>
            <Row className="BtnRow">
              <Col md={12} xs={12}>
                <Button
                  bsStyle="info"
                  type="submit"
                  id="submitButton"
                  disabled={this.props.sendingData}
                  style={{backgroundColor: this.props.buttonColor}}
                >
                  {languageConfig[this.state.default_lang].submit}
                </Button>
              </Col>
            </Row>
          </form>
        )}
      </div>
    );
  }
}

Reviews.propTypes = {
  add_review: PropTypes.func.isRequired,
  get_review_list: PropTypes.func.isRequired,
  get_review_details: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sendingData: state.reviewReducer.sendingData,
  reviewResponse: state.reviewReducer.reviewResponse,
  receivingReviewList: state.reviewReducer.receivingReviewList,
  reviewList: state.reviewReducer.reviewList,
  reviewDetails: state.reviewReducer.reviewDetails,
  updatedReviewResponse: state.reviewReducer.updatedReviewResponse,
  error: state.reviewReducer.error,
  message: state.alertsReducer.message,
  alertType: state.alertsReducer.alertType
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    update_review,
    get_review_details,
    add_review,
    get_review_list,
    renderAlert,
    clearAlert
  })
)(Reviews);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Reviews.js